export type LineOption = { name: string; value: string };

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const toScalarText = (value: unknown): string | null =>
  typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean'
    ? String(value)
    : null;

// Non-scalar values (e.g. rows DocumentDB split on a dotted key) are skipped so they never reach
// React as children.
const toOption = (name: unknown, value: unknown): LineOption[] => {
  const text = toScalarText(value);
  return typeof name === 'string' && name && text ? [{ name, value: text }] : [];
};

// Line options arrive as a legacy dict ({ Size: 'M' }) or, since LAS-247, as a list of name/value
// pairs ([{ name: 'Size', value: 'M' }]). Drop the dict branch once the backend stops sending it.
export const normalizeLineOptions = (raw: unknown): LineOption[] => {
  if (Array.isArray(raw)) {
    return raw.flatMap((pair) => (isRecord(pair) ? toOption(pair.name, pair.value) : []));
  }
  if (isRecord(raw)) return Object.entries(raw).flatMap(([name, value]) => toOption(name, value));
  return [];
};
